import React from 'react';
import {useTranslation} from '@app/hooks/useTranslation';
import {Container, LoadingSpinner} from '@tempo/core';
import {Topbar} from '@app/components/Layouts/elements/topbars/Topbar';
import {AccountSections} from '@app/components/Layouts/elements/stacks/AccountSections';
import AppsPermissions from '@app/components/Permissions/AppsPermissions';
import {useAppsController} from '@app/hooks/controllers/useAppsController';
import {TitleDescription} from '@app/components/Layouts/elements';
import {getStaticTranslations} from '@app/modules/translations';

const AppsPage = () => {
	const t = useTranslation();
	const {isLoading} = useAppsController();

	return (
		<>
			<Topbar />
			<Container maxW="container.md" mt="spacing.2xl" pb={38}>
				<AccountSections>
					{isLoading ? (
						<LoadingSpinner />
					) : (
						<>
							<TitleDescription
								title={t('applications.myapps')}
								detail={t('applications.youhaveauthorisedtheseapps')}
								alignItems="flex-start"
							/>
							<AppsPermissions />
						</>
					)}
				</AccountSections>
			</Container>
		</>
	);
};

export default AppsPage;

export async function getStaticProps({locale = ''}) {
	const translations = await getStaticTranslations(locale, {
		additionnalNamespaces: ['applications', 'permissions', 'error'],
	});
	return {
		props: {
			...translations,
		},
	};
}
